export const SET_CUSTOMERLIST = "SET_CUSTOMERLIST";

